import constate from 'constate';
import { useState } from 'react';
import { IFeedSpread } from '@tradingblock/types';

export const useSubscribedSymbolsContext = constate(() => {
  const [subscribedQuotes, setSubscribedQuotes] = useState<string[]>([]);
  const [subscribedSpreads, setSubscribedSpreads] = useState<IFeedSpread[]>([]);

  return {
    subscribedQuotes,
    setSubscribedQuotes,
    subscribedSpreads,
    setSubscribedSpreads,
  };
});
